var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Contact"}},[_c('b-container',{staticClass:"content-container"},[_c('h3',[_vm._v(" "+_vm._s(_vm.languageHelper.translate("common.contact", { locale: _vm.global.locale }))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }